import { Injectable } from '@angular/core';
import { AppBaseConfiguration, AppLanguage } from '@aston/foundation';

@Injectable({providedIn: 'root'})
export class AppConfiguration extends AppBaseConfiguration {
	appRootUrl: string;
	authenticationServerUrl: string;
	tenantFrontUrl: string;
	defaultLang: AppLanguage;
}
